/** @graphql cc **/

import type { DocumentNode } from 'graphql';
import type { QueryOptions } from '@apollo/client';

import {
	preloadPrefilteredExtensionList,
	type Extension,
	type UsePreFilteredExtensionsQueryOptions,
} from '@atlassian/forge-ui';

import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

export const preloadForgeApps = async ({
	cloudId,
	locale,
	types,
	context,
	includeHidden,
}: UsePreFilteredExtensionsQueryOptions): Promise<Extension[] | null> => {
	return preloadPrefilteredExtensionList(
		// This is s a special case that the query is from platform in DocumentNode not Relay TaggedNode
		// query can handle both Relay TaggedNode and DocumentNode but type is only declared as Relay TaggedNode
		queryAgg as unknown as <T, V>(
			options: Omit<QueryOptions<V>, 'query'> & { query: DocumentNode },
		) => Promise<{ data: T | null }>,
		{
			cloudId,
			locale,
			types,
			context,
			includeHidden,
		},
	);
};
